// Components==============
import indexActivity from 'actions/activity/index';
import FilterMenu from 'components/Layout/FilterMenu/FilterMenu';
import Layout from 'components/Layout/Layout';
import Button from 'components/UI/Button/Button';
import Container from 'components/UI/Container/Container';
import NoContent from 'components/UI/NoContent/NoContent';
import Title from 'components/UI/Title/Title';
import Token from 'components/UI/Token/Token';
import { useFilter } from 'hooks/useFilter';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import { useTranslate } from 'hooks/useTranslate';
import React, { useEffect } from 'react';
import {
  optionsFilter,
  phaseFilter,
  reduceFilter,
  searchFilter,
} from 'utilities/filters';
import './BuildingBlocks.module.scss';
// =========================

export default function BuildingBlocks() {
  const dispatch = useReduxAction();
  const translate = useTranslate();

  useEffect(() => {
    dispatch(indexActivity());
  }, []);

  // Filter logic
  const { filterValues, setFilterValues, initial } = useFilter(
    'buildingBlocks'
  );

  const f1 = searchFilter(filterValues[0].value as string);
  const f2 = optionsFilter(filterValues[1].value as number[], 'phases');
  // const f3 = optionsFilter(filterValues[2].value as number[], 'skills');
  const f4 = phaseFilter(filterValues[1].value as number[]);

  const phases = useRedux((state) => {
    const data = state.phase?.entities.allIds.map(
      (id) => state.phase?.entities.byId[id]
    );

    return reduceFilter([f1, f4], data);
  });

  const activities = useRedux((state) => {
    const data = state.activity?.entities.allIds
      .map((id) => state.activity?.entities.byId[id])
      .filter((a) => a?.type === 'regular')
      // filter vrije activiteiten duplicates
      .filter(
        (value, i, arr) =>
          arr.findIndex((activity) => activity?.name === value?.name) === i
      ).filter((activity) => activity?.slug !== "onbekend");

    return reduceFilter(
      [
        f1,
        f2,
        // f3
      ],
      data
    );
  });

  //

  return (
    <Layout
      filter={
        <FilterMenu
          filterValues={filterValues}
          setFilterValues={setFilterValues}
          initial={initial}
        />
      }
    >
      <NoContent
        page="buildingblocks"
        loading={false}
        hasContent={
          (activities ? activities?.length > 0 : false) ||
          (phases ? phases?.length > 0 : false)
        }
        loadOnce
      >
        <Container>
          <Title
            text="general.terms.building-blocks"
            loading={false}
            right={
              <Button to="/scan">
                {translate('general.terms.ar-scanner')}
              </Button>
            }
          />
          <div styleName="wrapper">
            {phases?.length ? (
              <div>
                <strong>{translate('project.terms.phases')}</strong>
                <div styleName="grid process-grid">
                  {phases?.map((e) => (
                    <div key={e?.id}>
                      <Token token={e} />
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
            {activities?.length ? (
              <div>
                <strong>{translate('project.terms.activities')}</strong>
                <div styleName="grid">
                  {activities?.map((e) => (
                    <div
                      key={e?.id}
                      styleName={
                        e?.name === 'Groowy'
                          ? 'Groowy'
                          : e?.name === 'Checkpunt'
                          ? 'Checkpunt'
                          : ''
                      }
                    >
                      <Token token={e} />
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
          </div>
        </Container>
      </NoContent>
    </Layout>
  );
}
